import styled from "@emotion/styled";
import { Flex } from "@otrium/core";
import BaseButton from "src/atoms/Button/BaseButton";

const PriceInfoWrapper = styled(Flex)`
  flex-wrap: wrap;
  margin-top: ${({ theme }) => theme.space[1]}px;
  font-weight: 400;
  line-height: 14px;
  font-size: 12px;
  align-items: flex-start;
  text-align: left;
`;
const Button = styled(BaseButton)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
  height: 12px;
  width: 12px;
  vertical-align: middle;
`;

const NoteWrapper = styled(Flex)`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.tone.sand};
  border-radius: 8px;
  padding: ${({ theme }) => theme.space[3]}px;
  width: 100%;
`;

export { Button, NoteWrapper, PriceInfoWrapper };
